import DilenskaEdit from './dilenska/Edit.vue';
import InterniProdejEdit from './interniProdej/Edit.vue';
import MontazDvEdit from './montazDV/Edit.vue';
import ProdejPultEdit from './prodejPult/Edit.vue';
import ProdejZboziEdit from './prodejZbozi/Edit.vue';
import ZapujckaEdit from './zapujcka/Edit.vue';
import KulanceEdit from './kulance/Edit.vue';
import InterniDilenskaEdit from './interniDilenska/Edit.vue';
import GaranceEdit from './garance/Edit.vue';
import PrevodNdEdit from './prevodND/Edit.vue';
import UdrzbaOvEdit from './udrzbaOV/Edit.vue';
import ZpetnyOdkupNdEdit from './zpetnyOdkupND/Edit.vue';
import DrobneSluzbyEdit from './drobneSluzby/Edit.vue';

export const Druhy = {
	DilenskaEdit,
	InterniProdejEdit,
	MontazDvEdit,
	ProdejPultEdit,
	ProdejZboziEdit,
	ZapujckaEdit,
	KulanceEdit,
	InterniDilenskaEdit,
	GaranceEdit,
	PrevodNdEdit,
	UdrzbaOvEdit,
	ZpetnyOdkupNdEdit,
	DrobneSluzbyEdit,
};
